import { createSlice } from 'utils/@reduxjs/toolkit';
import { SpeedControlBlockState } from './types';
import { reducers } from './reducers';

export const initialState: SpeedControlBlockState = {
  isLoading: false,
  error: null,
  data: { items: [], filterAttributes: [], total: 0 },
};

const slice = createSlice({
  name: 'speedControlBlock',
  initialState,
  reducers,
});

export const { actions: speedControlBlockActions } = slice;
export const { reducer: speedControlBlockReducer } = slice;
